var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgInfoTooltipUncolor = function SvgInfoTooltipUncolor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-376 -747)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "customStroke",
    transform: "translate(376 747)",
    fill: "none",
    stroke: "#0067b9",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1879.223 -9641.982) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1492.199 -10404.029)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "customFill",
    d: "M6.5,9.677a.912.912,0,0,1-.913-.913V4.738a.913.913,0,1,1,1.826,0V8.764A.912.912,0,0,1,6.5,9.677Z",
    transform: "translate(-5.585 -3.825)",
    fill: "#0067b9"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1492.016 -10396.144)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "customFill",
    cx: 1.095,
    cy: 1.095,
    r: 1.095,
    fill: "#0067b9"
  }))))));
};
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4NCiAgICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMzc2IC03NDcpIj4NCiAgICAgICAgPGcgY2xhc3M9ImN1c3RvbVN0cm9rZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzc2IDc0NykiIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzAwNjdiOSIgc3Ryb2tlLXdpZHRoPSIyIj4NCiAgICAgICAgICAgIDxjaXJjbGUgY3g9IjEwIiBjeT0iMTAiIHI9IjEwIiBzdHJva2U9Im5vbmUiLz4NCiAgICAgICAgICAgIDxjaXJjbGUgY3g9IjEwIiBjeT0iMTAiIHI9IjkiIGZpbGw9Im5vbmUiLz4NCiAgICAgICAgPC9nPg0KICAgICAgICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxODc5LjIyMyAtOTY0MS45ODIpIHJvdGF0ZSgxODApIj4NCiAgICAgICAgICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE0OTIuMTk5IC0xMDQwNC4wMjkpIj4NCiAgICAgICAgICAgICAgICA8cGF0aCBjbGFzcz0iY3VzdG9tRmlsbCIgZD0iTTYuNSw5LjY3N2EuOTEyLjkxMiwwLDAsMS0uOTEzLS45MTNWNC43MzhhLjkxMy45MTMsMCwxLDEsMS44MjYsMFY4Ljc2NEEuOTEyLjkxMiwwLDAsMSw2LjUsOS42NzdaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNS41ODUgLTMuODI1KSIgZmlsbD0iIzAwNjdiOSIvPg0KICAgICAgICAgICAgPC9nPg0KICAgICAgICAgICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTQ5Mi4wMTYgLTEwMzk2LjE0NCkiPg0KICAgICAgICAgICAgICAgIDxjaXJjbGUgY2xhc3M9ImN1c3RvbUZpbGwiIGN4PSIxLjA5NSIgY3k9IjEuMDk1IiByPSIxLjA5NSIgZmlsbD0iIzAwNjdiOSIvPg0KICAgICAgICAgICAgPC9nPg0KICAgICAgICA8L2c+DQogICAgPC9nPg0KPC9zdmc+DQo=";
export { SvgInfoTooltipUncolor as ReactComponent };